import { withInstall } from '@code-monkey-ui/utils'

import Scrollbar from './src/scrollbar.vue'

export const ElScrollbar = withInstall(Scrollbar)
export default ElScrollbar

export * from './src/util'
export * from './src/scrollbar'
export * from './src/thumb'
export * from './src/constants'
